import Vue from "vue";
import Router from "vue-router";
import Cookies from "js-cookie";
import envConfig from "./common/env";
import store from "./store/index";
import axios from "axios";
Vue.use(Router);
const router = new Router({
	mode: "history",
	base: "",
	routes: [
		{
			path: "/auth",
			component: require("./views/layout-auth.vue"),
			redirect: "/auth/login",
			children: [
				// ==================== 登录 ====================
				{
					path: "login",
					component: require("./views/auth/login.vue"),
				},
			],
		},
		{
			path: "/images",
			name: "images",
			component: require("./views/sendContent/images.vue"),
		},
		{
			path: "/files",
			name: "files",
			component: require("./views/sendContent/files.vue"),
		},
		{
			path: "/",
			redirect: "/auth/login",
			component: () => import("./views/layout-dashboard.vue"),
			children: [
				{
					path: "/workPlat",
					name: "WorkPlat",
					component: require("./views/weifa/workPlat.vue"),
					meta: {
						crumbList: ["预约管理"],
						menuName: "预约管理",
					},
				},
				{
					path: "/unit",
					component: require("./views/unitManagement/list"),
					meta: {
						crumbList: ["单位管理"],
						menuName: "单位管理",
					},
				},
				{
					path: "/staff",
					component: require("./views/staffManagement/list"),
					meta: {
						crumbList: ["人员管理"],
						menuName: "人员管理",
					},
				},
				{
					path: "/vacation",
					name: "Vacation",
					component: require("./views/vacation/vacation.vue"),
					meta: {
						crumbList: ["假期管理"],
						menuName: "假期管理",
					}
				},
				{
					path: "/time",
					name: "Time",
					component: require("./views/vacation/time.vue"),
					meta: {
						crumbList: ["预约时间管理"],
						menuName: "预约时间管理",
					}
				},
				{
					path: "/count",
					name: "Count",
					component: require("./views/count/count.vue"),
					meta: {
						crumbList: ["统计管理"],
						menuName: "统计管理",
					}
				},
				{
					path: "/system-manage",
					component: () => import("./views/systemManagement/layout.vue"),
					children: [
						{
							path: "changePassword",
							component: () => import("./views/systemManagement/changePassword.vue"),
							meta: {
								crumbList: ["系统管理", "修改密码"],
								menuName: "修改密码",
							},
						},			  
					]
				},
				{
					path: "/log-management",
					component: () => import("./views/logManagement/layout.vue"),
					children: [
						{
							path: "loginLog",
							component: () => import("./views/logManagement/loginLog.vue"),
							meta: {
								crumbList: ["日志管理", "登录日志"],
								menuName: "登录日志",
							},
						},			  
					]
				},
			],
			meta: {
				auth: false,
			}
		}
	]
});

router.beforeEach((to, from, next) => {
	const token = Cookies.get("token");
	if (to.fullPath != "/auth/login") {
		var usualMenus = store.state.menus;
		if (usualMenus.length) {
			var menus = JSON.parse(JSON.stringify(usualMenus));
			var filterRes = menus.filter(
				(menu) => menu.pathObject.path == to.fullPath
			);
			if (!filterRes.length) {
				if (menus.length == 3) {
					menus.shift();
				}
				var pushobj = {
					pathObject: {
						path: to.fullPath,
					},
					name: to.meta.menuName,
				};
				menus.push(pushobj);
				store.commit("MENUS", menus);
			}
		} else {
			var pushobj = {
				pathObject: {
					path: to.fullPath,
				},
				name: to.meta.menuName,
			};
			store.commit("MENUS", [pushobj]);
		}
	} else {
		store.commit("MENUS", []);
	}
	document.title = envConfig.configuration.projectName;
	if (to.matched.some((m) => m.meta.auth)) {
		if (token) {
			next();
		} else {
			next({
				path: "/auth/login",
				query: {
					returnUrl: to.fullPath,
				},
			});
		}
	} else {
		next();
	}
});
export default router;



// WEBPACK FOOTER //
// ./src/router.js